/* DO NOT MODIFY. This is an autogenerated file. */
/* eslint-disable */
import * as React from "react"
import type { SVGProps } from "react"

export const SvgFilePdfOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || "100%"}
    height={props.height || "100%"}
    fill="none"
    viewBox="0 0 24 24"
    data-name="SvgFilePdfOutline"
    {...props}
  >
    {props.children}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="M14 2.27V6.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C14.76 8 15.04 8 15.6 8h4.13M20 9.988V17.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C17.72 22 16.88 22 15.2 22H8.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C4 19.72 4 18.88 4 17.2V6.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C6.28 2 7.12 2 8.8 2h3.212c.733 0 1.1 0 1.446.083.306.073.598.195.867.36.303.185.562.444 1.08.963l3.19 3.188c.518.519.777.778.963 1.081a3 3 0 0 1 .36.867c.082.346.082.712.082 1.446"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.678 12.503q.33 0 .64.065v.001q.329.068.59.24.269.174.421.464c.115.203.165.445.165.71 0 .294-.05.556-.17.77-.112.2-.267.362-.463.477l-.005.002a1.9 1.9 0 0 1-.63.21q-.326.051-.68.051h-.29v1.508a.25.25 0 0 1-.25.25H6.25a.25.25 0 0 1-.25-.25v-4.248a.25.25 0 0 1 .25-.25zm-.422 1.842h.206q.153 0 .32-.011l.127-.019a1 1 0 0 0 .11-.035l.004-.002a.3.3 0 0 0 .133-.097l.005-.006.027-.057a.5.5 0 0 0 .014-.123c0-.1-.021-.145-.035-.164l-.004-.005a.3.3 0 0 0-.114-.096l-.009-.003a.6.6 0 0 0-.097-.037l-.113-.023a3 3 0 0 0-.284-.016h-.29zM11.998 12.503q.458 0 .887.145l.213.08q.31.135.565.359l.163.161q.23.256.38.59c.138.304.202.652.202 1.039 0 .396-.076.753-.238 1.063h-.001q-.226.44-.599.74-.36.287-.804.432l-.002.001a2.8 2.8 0 0 1-.856.138h-1.584a.25.25 0 0 1-.25-.25v-4.248a.25.25 0 0 1 .25-.25zm-.668 3.564h.314q.326 0 .605-.07.275-.075.464-.212a.95.95 0 0 0 .29-.351v-.003l.049-.114q.063-.181.064-.44 0-.259-.057-.444l-.042-.117a.86.86 0 0 0-.26-.345l-.007-.005a1 1 0 0 0-.29-.166l-.118-.037-.006-.002a2 2 0 0 0-.566-.074h-.44z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M18.067 12.466a.25.25 0 0 1 .2.245v.684a.25.25 0 0 1-.25.25h-1.736v.616h1.622a.25.25 0 0 1 .25.25v.684a.25.25 0 0 1-.25.25h-1.622v1.514a.25.25 0 0 1-.25.25h-.756a.25.25 0 0 1-.25-.25v-4.248a.25.25 0 0 1 .25-.25h2.743z"
    />
  </svg>
)
